/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterBookableAndSchedule } from './ClaimCenterBookableAndSchedule';
import {
    ClaimCenterBookableAndScheduleFromJSON,
    ClaimCenterBookableAndScheduleFromJSONTyped,
    ClaimCenterBookableAndScheduleToJSON,
} from './ClaimCenterBookableAndSchedule';

/**
 * 
 * @export
 * @interface ClaimCenterBookables
 */
export interface ClaimCenterBookables {
    /**
     * 
     * @type {Array<ClaimCenterBookableAndSchedule>}
     * @memberof ClaimCenterBookables
     */
    bookables: Array<ClaimCenterBookableAndSchedule>;
}

/**
 * Check if a given object implements the ClaimCenterBookables interface.
 */
export function instanceOfClaimCenterBookables(value: object): value is ClaimCenterBookables {
    if (!('bookables' in value) || value['bookables'] === undefined) return false;
    return true;
}

export function ClaimCenterBookablesFromJSON(json: any): ClaimCenterBookables {
    return ClaimCenterBookablesFromJSONTyped(json, false);
}

export function ClaimCenterBookablesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterBookables {
    if (json == null) {
        return json;
    }
    return {
        
        'bookables': ((json['bookables'] as Array<any>).map(ClaimCenterBookableAndScheduleFromJSON)),
    };
}

export function ClaimCenterBookablesToJSON(value?: ClaimCenterBookables | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bookables': ((value['bookables'] as Array<any>).map(ClaimCenterBookableAndScheduleToJSON)),
    };
}

